import { usePageMeta } from "@/hooks/usePageMeta";
import { faqs } from "@/mocks/faqs";
import { siteInfo } from "@/mocks/site";
import HeroSection from "@/pages/home/components/HeroSection";
import Ticker from "@/pages/home/components/Ticker";
import FeaturedTopics from "@/pages/home/components/FeaturedTopics";
import CategoryStrip from "@/pages/home/components/CategoryStrip";
import RankingPreview from "@/pages/home/components/RankingPreview";
import FaqSection from "@/pages/home/components/FaqSection";
import SubscribeSection from "@/pages/home/components/SubscribeSection";

const homeJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: siteInfo.name,
    url: "https://yuntuizq.cn/",
    description: siteInfo.description,
    inLanguage: "zh-CN",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://yuntuizq.cn/topics?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: siteInfo.name,
    url: "https://yuntuizq.cn/",
    email: siteInfo.email,
    description: siteInfo.tagline,
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  },
];

export default function Home() {
  usePageMeta({
    title: "瓜集社 · 全网热点合集与盘点目录｜独家吃瓜精选专题",
    description:
      "独家吃瓜合集和盘点都在这了，瓜集社把独家吃瓜精选专题按主题整理成目录，独家吃瓜全集与近期盘点一页看完，不用再翻聊天记录。",
    keywords: "独家吃瓜,独家吃瓜合集,独家吃瓜盘点,独家吃瓜精选,独家吃瓜全集",
    path: "/",
    jsonLd: homeJsonLd,
  });

  return (
    <>
      <HeroSection />
      <Ticker />
      <FeaturedTopics />
      <CategoryStrip />
      <RankingPreview />
      <FaqSection />
      <SubscribeSection />
    </>
  );
}